import type React from "react";

import styled from "styled-components";

interface DropdownOptionProps {
  id?: string;
  children: React.ReactNode;
  onClick?: () => void;
  row: number;
  dataTestId?: string;
  disabled?: boolean;
  border?: boolean;
}
export const DropdownOption: React.FC<DropdownOptionProps> = ({
  id,
  children,
  onClick = () => undefined,
  row,
  dataTestId,
  disabled = false,
  border,
}) => {
  return (
    <DropdownOptionElement id={id} onClick={onClick} data-testid={dataTestId} disabled={disabled}>
      <DropdownOptionElementContainer
        style={{ ...(row === 0 ? { borderTop: "none" } : {}) }}
        $disabled={disabled}
        $border={border}
      >
        {children}
      </DropdownOptionElementContainer>
    </DropdownOptionElement>
  );
};

const DropdownOptionElementContainer = styled.div<{ $disabled?: boolean; $border?: boolean }>`
  min-width: 125px;
  height: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  padding: 4px 12px;
  color: ${({ theme }) => theme.colors.redesign.db100};
  font-weight: 500;
  font-size: 14px;
  border-top: ${({ theme, $border }) => ($border ? `1px solid ${theme.colors.greys.silver}` : "none")};
  ${props => (props.$disabled ? `color: ${props.theme.colors.greys.pinkish};` : "")}
  user-select: none;
  cursor: ${props => (props.$disabled ? "default" : "pointer")};
`;

const DropdownOptionElement = styled.li<{ disabled?: boolean }>`
  min-height: 45px;
  list-style: none;
  transition: background-color 0.2s;

  :hover {
    cursor: pointer;
    background: ${props => (props.disabled ? "transparent" : props.theme.colors.redesign.db10)};
    color: ${props => (props.disabled ? props.theme.colors.greys.pinkish : props.theme.colors.redesign.b100)};
  }

  svg {
    ${props => (props.disabled ? "opacity: 0.75" : "")}
  }
`;
